const { contrastColor } = require("contrast-color");

export const fontColorAccordingToHex = (hexColor) => {
  if (!hexColor) {
    return "#000000";
  }

  return contrastColor({ bgColor: hexColor, defaultColor: "#ffffff" });
};
